// AUTOGENERATED: DO NOT EDIT

import { AnimatedSprite, Spritesheet, SpritesheetData, Texture } from "pixi.js";
import img from "../../assets/img/fish/grayfish-1.png";
import { SpriteSheetJSON } from "./type";

const data: SpriteSheetJSON = {
  frames: {
    "grayfish-1 0.aseprite": {
      frame: {
        x: 0,
        y: 0,
        w: 64,
        h: 32,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 64,
        h: 32,
      },
      sourceSize: {
        w: 64,
        h: 32,
      },
      duration: 100,
    },
    "grayfish-1 1.aseprite": {
      frame: {
        x: 64,
        y: 0,
        w: 64,
        h: 32,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 64,
        h: 32,
      },
      sourceSize: {
        w: 64,
        h: 32,
      },
      duration: 100,
    },
    "grayfish-1 2.aseprite": {
      frame: {
        x: 128,
        y: 0,
        w: 64,
        h: 32,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 64,
        h: 32,
      },
      sourceSize: {
        w: 64,
        h: 32,
      },
      duration: 100,
    },
    "grayfish-1 3.aseprite": {
      frame: {
        x: 192,
        y: 0,
        w: 64,
        h: 32,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 64,
        h: 32,
      },
      sourceSize: {
        w: 64,
        h: 32,
      },
      duration: 100,
    },
  },
  meta: {
    app: "https://www.aseprite.org/",
    version: "1.3.9.2-arm64",
    image: "grayfish-1.png",
    format: "RGBA8888",
    size: {
      w: 256,
      h: 32,
    },
    scale: "1",
    frameTags: [],
    layers: [
      {
        name: "Layer 1",
        opacity: 255,
        blendMode: "normal",
      },
    ],
    slices: [],
  },
  animations: {
    swim: [
      "grayfish-1 0.aseprite",
      "grayfish-1 1.aseprite",
      "grayfish-1 2.aseprite",
      "grayfish-1 3.aseprite",
    ],
  },
};
export const grayfish1 = async () => {
  const texture = Texture.from(img);
  texture.source.scaleMode = "nearest";

  const spritesheet = new Spritesheet(texture, data as SpritesheetData);

  await spritesheet.parse();

  const swim = new AnimatedSprite(spritesheet.animations.swim);

  swim.width = 128;
  swim.height = 64;
  swim.anchor.set(0.5, 0.5);

  return swim;
};
